import { useTranslation } from 'react-i18next';
import { useTabs } from '@shared/hooks';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { NavLink } from './navElement';
import { Icon, Spinner } from '@shared/widgets';
import SwapIcon from '@assets/icons/swap.svg';
import EarthIcon from '@assets/icons/earth.svg';
import CrownIcon from '@assets/icons/crown.svg';
import VcfcIcon from '@assets/icons/logo/logo-vcfc-small.svg';

interface NavigationProps {
  className?: string;
}

export const Navigation = (props: NavigationProps) => {
  const tabState = useTabs();
  const { t } = useTranslation('payments');

  return (
    <div className={cn('flex w-full items-start justify-start gap-2', 'max-[976px]:flex-col', props.className)}>
      <NavLink
        className='max-[976px]:w-full'
        title={t(`navigation.${PaletteUtils.isVcfcPalette ? 'betweenVcfcAccount' : 'betweenInsigniaAccount'}`)}
        icon={<Icon icon={<SwapIcon width='24' height='24' />} className='-rotate-90' color='white' />}
        to={RoutePaths.paymentsInsignia.onNavigate()}
      />
      {/* <NavLink
        className='max-[976px]:w-full'
        title={t('navigation.sepaTransfer')}
        icon={
          <Icon
            icon={
              <Text className='-ml-0.5' size='2xl' color='white'>
                €
              </Text>
            }
            color='white'
          />
        }
        to={RoutePaths.paymentsOtherSepa.onNavigate()}
      /> */}
      <NavLink
        className='max-[976px]:w-full'
        title={t('navigation.otherBankTransfer')}
        icon={<Icon icon={<EarthIcon />} color='white' />}
        to={RoutePaths.paymentsOther.onNavigate()}
      />
      {tabState.loading ? (
        <Spinner little />
      ) : (
        tabState.hasCard && (
          <NavLink
            className='max-[976px]:w-full'
            title={t('navigation.cardAccountSettlement')}
            icon={<Icon icon={PaletteUtils.isVcfcPalette ? <VcfcIcon /> : <CrownIcon />} color='white' />}
            to={RoutePaths.paymentsCard.onNavigate()}
          />
        )
      )}
    </div>
  );
};
